import React, { forwardRef } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import FormErrorMessage from '../Errormessage';

const InputBox = forwardRef(({ label, icon, className, messages, error, onChange, name, type = "text", placeholder, value, authInput = false, disabled, onCopy, onPaste, isEdit = false }, ref) => {

    return (
        <div>
            <TextField
                variant="outlined"
                label={label}
                disabled={disabled}
                onCopy={onCopy}
                onPaste={onPaste}
                defaultValue={value}
                name={name}
                type={type}
                inputRef={ref}
                multiline={type === "textarea"}
                rows={type === "textarea" ? 4 : 1}
                onChange={onChange}
                className={`${className} kg_input_wrappper`}
                placeholder={placeholder}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        borderRadius: authInput ? "10px" : "4px",
                        backgroundColor: "#fff",
                        border: authInput ? "none" : "1px solid #D9D9D9",
                        boxShadow: authInput ? "0px 0px 10px 0px #0000001A" : "none",
                        "& fieldset": {
                            border: "none",
                        },
                        "&:hover fieldset": {
                            border: authInput ? "none" : "1px solid #000",
                        },
                        "&.Mui-focused fieldset": {
                            border: "none",
                        },
                        "& .MuiInputBase-input": {
                            fontWeight: authInput ? "700" : "400",
                            color : error ? 'red !important' : '#2E2E2E'
                        },
                    },
                    
                }}
                InputLabelProps={{
                    shrink: isEdit || value && value !== '',
                    style :{
                            color: '#2E2E2E',
                            backgroundColor: "#FFFFFF",
                            paddingLeft: "2px",
                            paddingRight: "2px",
                            fontFamily: 'Gotham',
                            fontSize: authInput ? "20px" : "16px",
                            fontWeight: "400",
                            lineHeight: "26px",
                    }
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" sx={{cursor :"pointer"}}>
                            {icon}
                        </InputAdornment>
                    ),
                }}
            />
            <div>
                <FormErrorMessage error={error} messages={messages} />
            </div>
        </div>
    );
});

export default InputBox;
